import { useState } from "react";
import { faqItems } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <Reveal className="lg:col-span-4">
            <div>
              <span className="text-xs text-primary-600">使用说明</span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                常见问题
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                关于更新频率、信息来源与线索投稿的疑问，这里一次讲清。仍有问题可通过客户端内的帮助中心联系我们。
              </p>
            </div>
          </Reveal>

          <div className="lg:col-span-8">
            <div className="border-t border-background-200">
              {faqItems.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <Reveal key={item.q} delay={Math.min(index, 4) * 60}>
                    <div className="border-b border-background-200">
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        className="flex w-full items-center justify-between gap-4 py-5 text-left"
                      >
                        <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                          {item.q}
                        </span>
                        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-700">
                          <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                        </span>
                      </button>
                      <div
                        className={`grid transition-all duration-300 ease-out ${
                          isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                        }`}
                      >
                        <div className="overflow-hidden">
                          <p className="pb-5 pr-10 text-sm leading-relaxed text-foreground-600">
                            {item.a}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}